module.exports = __webpack_public_path__ + "img/05.f52758df.png";